<template>
  <div>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true" label-position="left">
        <el-form-item label="添加时间">
          <date-range-picker
            :value="addTime"
            @getChange="value => (addTime = value)"
          />
        </el-form-item>
        <el-form-item label="银行编号">
          <el-input
            v-model.trim="searchForm.newCode"
            placeholder="请输入银行编号"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item label="银行名称">
          <el-autocomplete
            v-model.trim="searchForm.bankName"
            :fetch-suggestions="querySearch"
            placeholder="请输入银行名称"
            :trigger-on-focus="false"
            value-key="name"
            clearable
            style="width: 202px"
          >
          </el-autocomplete>
        </el-form-item>
        <el-button
          type="primary"
          :loading="searchLoading"
          @click="searchBtnClick"
          >查询</el-button
        >
        <el-button type="default" :loading="exportLoading" @click="handleExport"
          >导出</el-button
        >
      </el-form>
    </module-card>
    <module-card title="银行管理">
      <auth-button
        opt="add_bank"
        icon="el-icon-plus"
        label="新增支行"
        class="editBtn"
        @click.native="toAddBranch"
      >
        新增银行
      </auth-button>
      <batch-import
        class="batchImport"
        button-text="批量新增支行"
        submit-name="batchAddBranch"
        templateName="批量新增支行模板"
        dialog-title="批量新增支行"
        :otherTips="['支行命名格式规范：城市+支行名称（深圳市南山支行）']"
        :tableList="[
          { label: '银行编号', prop: 'newCode' },
          { label: '银行名称', prop: 'bankName' },
          { label: '失败原因', prop: 'errorMsg' }
        ]"
        @submit="importSubmit"
      />
      <el-table class="table" border :data="tableData" v-loading="searchLoading">
        <el-table-column
          v-for="(item, index) in columns"
          :label="item.label"
          :prop="item.key"
          :key="index"
          :formatter="formatColumns"
        ></el-table-column>
        <el-table-column label="关联银行">
          <template slot-scope="scope">
            <auth-button
              auth-type="span"
              opt="edit_bank"
              label="查看详情"
              class="editBtn"
              @click.native="checkDetail(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <auth-button
              auth-type="span"
              opt="edit_bank"
              label="修改"
              class="editBtn"
              @click.native="updateBranchInfo(scope.row)"
            />
            <auth-button
              auth-type="span"
              opt="edit_bank"
              :label="scope.row.status === 1 ? '关闭' : '启用'"
              class="editBtn"
              @click.native="updateStatus(scope.row)"
            />
            <auth-button
              auth-type="span"
              opt="edit_bank"
              label="操作记录"
              class="editBtn"
              @click.native="checkOperateLog(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :count="total"
        :page-no="pageNo"
        :size="pageSize"
        @changePage="onChangePage"
      />
    </module-card>
    <dialog-info
      :visible.sync="showAddDialog"
      :title="isAdd?'新增支行':'修改支行'"
      @confirm="submitAddBranch"
      @close="closeAddDialog"
      size="middle"
      footerAlign="center"
    >
      <el-form
        ref="branchForm"
        :model="branchForm"
        :rules="ruleData"
        label-width="125px"
        label-position="left"
      >
        <el-form-item label="银行名称：" prop="name">
          <el-input
            v-model.trim="branchForm.name"
            placeholder="请输入完整支行名称，命名格式：银行+城市+支行名称（兴业银行深圳市南山支行）"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择关联分行：" prop="branchCode">
          <select-page
            class="bankSelect"
            :value="branchForm.branchCode"
            placeholder="请选择关联分行"
            :request-data="requestData"
            option-value="code"
            option-name="name"
            valueName="name"
            remoteKey="bankName"
            requestUrl="getBranchList"
            @getSelect="getRelationBranch">
          </select-page>
        </el-form-item>
        <el-form-item label="银行卡bin" prop="bin">
          <el-input v-model.trim="branchForm.bin" placeholder="请输入银行Bin" clearable></el-input>
        </el-form-item>
        <bank-branch
          label-width="125px"
          ref="bankBranchForm"
          :value="bankBranch"
          v-model="bankBranch"
          :readOnly="false"
          @getValue="getBankBranch" />
        <el-form-item label="管理机构编号：" prop="organNumber">
          <el-input
            v-model.trim="branchForm.organNumber"
            placeholder="请输入银行系统中的机构编号"
          ></el-input>
        </el-form-item>
      </el-form>
    </dialog-info>
    <dialog-info
      :visible.sync="showBranchDetailDialog"
      title="查看详情"
      :showCancelBtn="false"
      :showConfirmBtn="false"
      size="large"
      footerAlign="center"
    >
      <el-form :model="relationBranchForm" :inline="true" label-position="left">
        <el-form-item label="银行编号">
          <el-input v-model.trim="relationBranchForm.relationBankCode" placeholder="请输入银行编号" clearable />
        </el-form-item>
        <el-form-item label="银行名称">
          <el-input v-model.trim="relationBranchForm.relationBankName" placeholder="请输入银行名称" clearable />
        </el-form-item>
        <el-button type="primary" :loading="searchBranchLoading" @click="getBranchDetailList">查询</el-button>
      </el-form>
      <el-table class="table" border :data="branchDetailList" v-loading="searchBranchLoading">
        <el-table-column
          label="银行名称"
          prop="name">
        </el-table-column>
        <el-table-column
          label="银行编号"
          prop="code">
        </el-table-column>
        <el-table-column
          label="银行类型"
          prop="bankType"
          :formatter="formatColumns"
         ></el-table-column>
      </el-table>
      <pagination :count="detailPagination.total" :page-no="detailPagination.pageNo" :size="detailPagination.pageSize"
                  @changePage="value => { this.detailPagination.pageNo = value; getBranchDetailList() }"/>
    </dialog-info>
    <!-- 操作记录查询对话框 -->
    <dialog-info
      :visible.sync="showOperateLogDialog"
      title="操作记录"
      size="middle"
      :showCancelBtn="false"
      footerAlign="center"
      confirmText="关闭"
      @confirm="showOperateLogDialog=false"
    >
    <el-table border :data="operateRecordsPageData" v-loading="recordsLoading">
      <el-table-column label="更新时间" prop="createTime"></el-table-column>
      <el-table-column label="操作人" prop="operatorId"></el-table-column>
      <el-table-column label="操作内容" prop="operationContent"></el-table-column>
    </el-table>
    <pagination :count="recordsPagination.total" :page-no="recordsPagination.pageNo" :size="recordsPagination.pageSize"
                  @changePage="value => { this.recordsPagination.pageNo = value; setRecordsDataByPage() }"/>
    </dialog-info>
  </div>
</template>

<script>
import dateRangePicker from '@/components/dateRangePicker'
import dialogInfo from '@/components/layout/dialogInfo'
import batchImport from '@/components/upload/batchImport'
import pagination from '@/components/pagination'
import bankBranch from '@/components/bankBranch'
import { downJumpConfirm } from '@/assets/js/utils'
import selectPage from '@/components/selectPage'
export default {
  components: { dateRangePicker, dialogInfo, batchImport, pagination, bankBranch, selectPage },

  data () {
    return {
      addTime: [],
      searchForm: {
        bankName: '',
        newCod: ''
      },
      bankTypeListHashMap: {
        1: '总行',
        2: '分行',
        3: '支行'
      },
      statusMap: {
        1: '启用',
        0: '关闭'
      },
      branchForm: {
        name: '',
        branchCode: '',
        bin: '',
        unionpayCode: '',
        organNumber: '',
        address: {
          provinceName: '',
          provinceNo: '',
          cityName: '',
          cityNo: '',
          bankNo: '',
          bankName: ''
        }
      },
      relationBranchForm: {
        relationBankName: '',
        relationBankCode: ''
      },
      ruleData: {
        name: [
          {
            required: true,
            message: '请输入银行名称',
            trigger: 'blur'
          }
        ],
        branchCode: [
          {
            required: true,
            message: '选择关联分行',
            trigger: 'change'
          }
        ],
        unionpayCode: [
          {
            required: true,
            message: '请输入支行联行号',
            trigger: 'blur'
          }
        ],
        bin: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入银行卡BIN'))
            } else {
              if (!/^([0-9]+,)*[0-9]+$/.test(value)) {
                callback(new Error('请输入正确格式的银行卡BIN'))
              } else {
                const arrayBin = value.split(',')
                const setBin = new Set(arrayBin)
                if (arrayBin.length !== setBin.size) {
                  callback(new Error('卡BIN输入重复'))
                } else {
                  callback()
                }
              }
            }
          },
          required: true,
          trigger: 'blur'
        }]
      },
      isAdd: true,
      bankList: [],
      branchList: [],
      searchLoading: false,
      exportLoading: false,
      showAddDialog: false,
      showBranchDetailDialog: false,
      searchBranchLoading: false,
      branchDetailList: [],
      detailPagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [{ name: '中国国工商银行' }],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      columns: [
        {
          label: '创建时间',
          key: 'createTime'
        },
        {
          label: '银行类型',
          key: 'bankType'
        },
        {
          label: '银行名称',
          key: 'name'
        },
        {
          label: '分行名称',
          key: 'branchName'
        },
        {
          label: '银行卡Bin',
          key: 'bin'
        },
        {
          label: '银行编号',
          key: 'newCode'
        },
        {
          label: '状态',
          key: 'status'
        }
      ],
      relationBankCode: '',
      operationRecordsData: [],
      showOperateLogDialog: false,
      recordsLoading: false,
      operateRecordsPageData: [],
      recordsPagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      requestData: { bankName: '' }
    }
  },

  computed: {
    bankBranch () {
      return {
        bankNameCode: this.branchForm.address.bankNo, // 银行类型编码
        bankCityCode: this.branchForm.address.cityNo, // 银行网点市编码
        bankAreaCode: this.branchForm.address.provinceNo, // 银行网点省编码
        bankBranchCode: this.branchForm.unionpayCode, // 分行id
        bankName: this.branchForm.address.bankName, // 银行类型编码
        bankCity: this.branchForm.address.cityName, // 银行网点市编码
        bankArea: this.branchForm.address.provinceName, // 银行网点省编码
        bankBranch: this.branchForm.bankBranch // 分行id
      }
    }
  },

  created () {
    this.searchBtnClick()
  },

  mounted () {},

  methods: {
    formatColumns (row, column) {
      if (column.label === '银行类型') {
        return this.bankTypeListHashMap[row.bankType] || ''
      } else if (column.label === '状态') {
        return this.statusMap[row.status] || ''
      } else {
        return row[column.property]
      }
    },
    searchBtnClick () {
      this.pageNo = 1
      this.getList()
    },
    getList () {
      const reqParams = {
        ...this.searchForm,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        addTimeStart: this.addTime && this.addTime.length ? this.addTime[0] : '',
        addTimeEnd: this.addTime && this.addTime.length ? this.addTime[1] : ''
      }
      this.searchLoading = true
      this.$axios.post(this.$api.branchPageList, reqParams).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.tableData = []
          this.total = 0
        }
      }).catch(() => {
        this.searchLoading = false
      })
    },
    onChangePage (val) {
      this.pageNo = val
      this.getList()
    },
    toAddBranch () {
      this.isAdd = true
      this.showAddDialog = true
      this.$nextTick(() => {
        this.$refs.branchForm.resetFields()
        this.$refs.bankBranchForm.$refs.form.resetFields()
      })
    },
    querySearch (queryString, cb) {
      const result = []
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (queryString === '') {
          cb(result)
        } else {
          this.$axios
            .post(this.$api.bankFuzzySearch, {
              bankName: queryString
            })
            .then(res => {
              if (res.respCode === '0') {
                var result = res.data.list
                cb(result)
              } else {
                result = []
                cb(result)
              }
            })
        }
      }, 1000)
    },
    getBankBranch (val) {
      this.branchForm.address.bankNo = val.bankNameCode // 银行类型编码
      this.branchForm.address.cityNo = val.bankCityCode // 银行类型编码
      this.branchForm.address.provinceNo = val.bankAreaCode // 银行类型编码
      this.branchForm.unionpayCode = val.bankBranchCode // 分行id
      this.branchForm.address.bankName = val.bankName // 银行类型编码
      this.branchForm.address.cityName = val.bankCity // 银行类型编码
      this.branchForm.address.provinceName = val.bankArea // 银行类型编码
      this.branchForm.bankBranch = val.bankBranch // 分行id
    },
    closeAddDialog () {
      this.showAddDialog = false
    },
    getRelationBranch (result) {
      // console.log(result)
      if (result) {
        this.branchForm.branchCode = result.value
      } else {
        this.branchForm.branchCode = ''
      }
    },
    submitAddBranch () {
      let formValid = true
      this.$refs.branchForm.validate(valid => {
        if (!valid) formValid = false
      })
      this.$refs.bankBranchForm.$refs.form.validate(valid => {
        if (!valid) formValid = false
      })
      if (formValid) {
        let api
        if (this.isAdd) {
          api = 'addBranch'
        } else {
          api = 'editBranch'
        }
        this.$axios.post(this.$api[api], this.branchForm).then(res => {
          if (res.respCode === '0') {
            this.closeAddDialog()
            this.$message({
              type: 'success',
              message: this.isAdd ? '新增成功' : '修改成功'
            })
            this.searchBtnClick() // 刷新列表
          }
        })
      }
    },
    getBranchDetailList (row) {
      const params = {
        ...this.relationBranchForm,
        pageNo: this.detailPagination.pageNo,
        pageSize: this.detailPagination.pageSize,
        newCode: this.relationBankCode
      }
      this.searchBranchLoading = true
      this.$axios.post(this.$api.relativeBranchList, params).then(res => {
        this.searchBranchLoading = false
        if (res.respCode === '0' && res.data.list) {
          this.branchDetailList = res.data.list
          this.detailPagination.total = res.data.count
        } else {
          this.branchDetailList = []
          this.detailPagination.total = 0
        }
      }).catch(() => {
        this.searchBranchLoading = false
        this.branchDetailList = []
        this.detailPagination.total = 0
      })
    },
    checkDetail (row) {
      this.detailPagination.pageNo = 1
      this.detailPagination.pageSize = 10
      this.relationBankCode = row.newCode
      this.showBranchDetailDialog = true
      this.getBranchDetailList()
    },
    updateStatus (row) {
      const content = row.status === 1 ? '确认关闭？' : '确认启用？'
      this.$confirm(content, '温馨提示', {
        type: 'warning'
      }).then(() => {
        const params = {
          newCode: row.newCode,
          status: row.status === 1 ? 0 : 1
        }
        this.$axios.post(this.$api.updateBranchStatus, params).then(res => {
          if (res.respCode === '0') {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.getList()
          }
        })
      })
    },
    checkOperateLog (row) {
      this.showOperateLogDialog = true
      this.recordsPagination.pageNo = 1
      this.recordsPagination.pageSize = 10
      const params = { bankCode: row.newCode }
      this.recordsLoading = true
      this.$axios.post(this.$api.operationRecords, params).then(res => {
        this.recordsLoading = false
        if (res.respCode === '0') {
          this.operationRecordsData = res.data
          this.recordsPagination.total = res.data.length || 0
          this.setRecordsDataByPage()
        } else {
          this.operationRecordsData = []
          this.operateRecordsPageData = []
          this.recordsPagination.total = 0
        }
      }).catch(() => {
        this.recordsLoading = false
        this.operationRecordsData = []
        this.operateRecordsPageData = []
        this.recordsPagination.total = 0
      })
    },
    setRecordsDataByPage () { // 操作记录前端分页
      const begin = (this.recordsPagination.pageNo - 1) * this.recordsPagination.pageSize
      const end = this.recordsPagination.pageSize * this.recordsPagination.pageNo
      this.operateRecordsPageData = this.operationRecordsData.slice(begin, end)
    },
    updateBranchInfo (row) {
      this.isAdd = false
      this.$nextTick(() => {
        this.$refs.branchForm.clearValidate()
        this.$refs.bankBranchForm.$refs.form.clearValidate()
      })
      this.showAddDialog = true
      const params = { newCode: row.newCode }
      this.$axios.post(this.$api.getBranchInfo, params).then(res => {
        if (res.respCode === '0') {
          this.branchForm = res.data
        } else {
          this.$message({
            type: 'error',
            message: res.respMsg
          })
        }
      })
    },
    importSubmit (result) {
      if (result) {
        this.getList()
      }
    },
    handleExport () {
      this.exportLoading = true
      const params = {
        ...this.searchForm,
        addTimeStart: this.addTime && this.addTime.length ? this.addTime[0] : '',
        addTimeEnd: this.addTime && this.addTime.length ? this.addTime[1] : ''
      }
      this.$axios.post(this.$api.exportBranchList, params).then((res) => {
        this.exportLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.table {
  margin-top: 20px;
}
</style>
